import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip.tsx";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

export interface EngagementInfoTooltipProps {
    label: string;
    description: string;
}

export function EngagementInfoTooltip({ label, description }: EngagementInfoTooltipProps) {
    if (!description) {
        return null;
    }

    return (
        <Tooltip delay={500}>
            <TooltipTrigger aria-label={label} className="text-muted-fg hover:bg-fg/6 hover:text-fg focus-visible:ring-ring/40 touch-target inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors focus-visible:ring-2 focus-visible:outline-hidden">
                <InformationCircleIcon aria-hidden="true" className="size-4" />
            </TooltipTrigger>
            <TooltipContent inverse className="text-xs">
                {description}
            </TooltipContent>
        </Tooltip>
    );
}
